import {
    Link,
    RichTextEditor,
    RichTextEditorStylesNames,
} from "@mantine/tiptap";
import { useEditor } from "@tiptap/react";
import { Stack, StackProps, Text } from "@mantine/core";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import TextAlign from "@tiptap/extension-text-align";
import Superscript from "@tiptap/extension-superscript";
import SubScript from "@tiptap/extension-subscript";
import Highlight from "@tiptap/extension-highlight";
import { ReactNode } from "react";
// interface ICustomTextEditor {
//     onChange: (value: string) => void;
//     value: string;
//     placeholder?: string;
//     styles?: RichTextEditorStylesNames;
//     title?: string;
//     withAsterisk?: boolean;
//     containerProps?: StackProps;
//     height?: number;
//     error?: ReactNode;
//     maxHeight?: number;
//     minHeight?: number;
// }
const errorStyle = {
    color: "red",
    borderColor: "red",
};
function CustomRichTextEditor({
    onChange,
    value = "",
    placeholder,
    title,
    withAsterisk = true,
    containerProps,
    height,
    maxHeight = 500,
    minHeight = 100,
    error,
}) {
    const editor = useEditor({
        extensions: [
            StarterKit,
            Underline,
            Link,

            Superscript,
            SubScript,
            Highlight,
            TextAlign.configure({ types: ["heading", "paragraph"] }),
        ],
        content: value,
        onUpdate: (value) =>
            onChange &&
            onChange(
                value?.editor?.getHTML() === "<p></p>" ? " " : value?.editor?.getHTML(),
            ),
    });

    return (
        <Stack {...containerProps}>
            {/* <Text size={"sm"} fw={"500"}>
                {title}{" "}
                {withAsterisk && (
                    <Text c='red' component='span'>
                        *
                    </Text>
                )}
            </Text> */}
            <RichTextEditor
                editor={editor}
                // placeholder={placeholder}
                styles={{
                    content: error
                        ? { height, maxHeight, minHeight, overflowY: "auto", ...errorStyle }
                        : { height, maxHeight, minHeight, overflowY: "auto" },
                    root: error ? errorStyle : {},
                    control: error ? errorStyle : {},
                }}>
                <RichTextEditor.Toolbar sticky stickyOffset={60}>
                    <RichTextEditor.ControlsGroup>
                        <RichTextEditor.Bold />
                        <RichTextEditor.Italic />
                        <RichTextEditor.Underline />
                        <RichTextEditor.Strikethrough />
                        <RichTextEditor.ClearFormatting />
                        <RichTextEditor.Highlight />
                        <RichTextEditor.Code />
                    </RichTextEditor.ControlsGroup>

                    <RichTextEditor.ControlsGroup>
                        <RichTextEditor.H1 />
                        <RichTextEditor.H2 />
                        <RichTextEditor.H3 />
                        <RichTextEditor.H4 />
                    </RichTextEditor.ControlsGroup>

                    <RichTextEditor.ControlsGroup>
                        <RichTextEditor.Blockquote />
                        <RichTextEditor.Hr />
                        <RichTextEditor.BulletList />
                        <RichTextEditor.OrderedList />
                        <RichTextEditor.Subscript />
                        <RichTextEditor.Superscript />
                    </RichTextEditor.ControlsGroup>

                    <RichTextEditor.ControlsGroup>
                        <RichTextEditor.Link />
                        <RichTextEditor.Unlink />
                    </RichTextEditor.ControlsGroup>

                    <RichTextEditor.ControlsGroup>
                        <RichTextEditor.AlignLeft />
                        <RichTextEditor.AlignCenter />
                        <RichTextEditor.AlignJustify />
                        <RichTextEditor.AlignRight />
                    </RichTextEditor.ControlsGroup>
                </RichTextEditor.Toolbar>

                <RichTextEditor.Content />
            </RichTextEditor>

            {error && (
                <Text color='red' size={"xs"}>
                    {error}
                </Text>
            )}
        </Stack>
    );
}

export default CustomRichTextEditor;
